


























































































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import { GREEN, REASONS, RED, YELLOW } from "@/resources/constants/busyReasons";
import { SPACE_TYPE, USER_TYPE } from "@/resources/constants/space";
import { LocaleMessage } from "vue-i18n";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { i18n } from "@/resources/locales";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import Chime from "@/resources/mixins/chime/chime";
import UserValidator from "@/resources/mixins/userValidator";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
@Component({
  name: "user-online-component",
  directives: { ClickOutsideDirective },
})
export default class UserOnlineComponent extends mixins(
  NotificationEvent,
  Chime,
  UserValidator
) {
  [x: string]: any;
  @Prop() userOnline;
  @Prop({ default: false, type: [Boolean] }) inCall: boolean;
  @Prop() experts;
  @Prop() knowledge;
  @Prop() projects;
  SPACE_TYPE = SPACE_TYPE;
  USER_TYPE = USER_TYPE;
  isWebinarHost = false;
  isOpenActions = false;
  isTeams = false;
  constructor() {
    super();
  }
  mounted() {
    this.isWebinarHost = this.userOnline.spaceUser
      ? this.userOnline.spaceUser.isWebinarHost
      : this.userOnline.isWebinarHost;

    const space = this.$store.getters["SpaceStore/getSpace"];
    this.isTeams = space?.superSpace?.isTeams;
  }
  get user() {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  get space() {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  get meetingWebinar() {
    return (
      this.$store.getters["MeetingStore/getMeetingType"] ===
      MEETING_TYPE.WEBINAR
    );
  }
  get availableStatusReason(): LocaleMessage | string {
    if (this.userOnline && this.userOnline.user.availableStatusReason) {
      const reason = REASONS.filter(
        (a) => a.type === this.userOnline.user.availableStatusReason
      );
      return reason.length > 0
        ? reason[0].label
        : this.userOnline.user.availableStatusReason;
    }
    return "";
  }
  get unSeenMessage(): boolean {
    return (
      this.$store.getters["ChatStore/getUnSeenMessage"].filter(
        (a) => a === this.userOnline.id
      ).length > 0
    );
  }
  get isMultiWebinar(): boolean {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    return (
      meetingType === MEETING_TYPE.WEBINAR &&
      space.superSpace.isMultiWebinarActivated
    );
  }
  sidebarFull(): boolean {
    return this.$store.getters["SidebarStore/getSidebarFull"];
  }
  setAvatarColor(color: string): string {
    switch (color) {
      case GREEN.type:
        return GREEN.color;
      case RED.type:
        return RED.color;
      case YELLOW.type:
        return YELLOW.color;
      default:
        return RED.color;
    }
  }
  async openChat(): Promise<void> {
    await this.$store.dispatch("ChatStore/setMessagesAction", []);
    await this.$store.dispatch("ChatStore/setUserChatAction", this.userOnline);
    await this.$store.dispatch("SidebarStore/setOpenChatAction", false);
    this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
    await this.$store.dispatch(
      "ChatStore/setChatTypeAction",
      CHAT_TYPE.ONE_TO_ONE
    );
    await this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    await this.$store.dispatch("SidebarStore/setOpenChatAction", true);
    this.$store.dispatch("ChatStore/setMinimizeChatAction", false);
    await this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    await this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
      id: this.userOnline.id,
    });
    const tooltip = document.getElementsByClassName(
      "vs-tooltip left shadow"
    )[0];
    if (tooltip) tooltip.remove();
  }
  checkSpace(userOnline: any) {
    if (
      !userOnline ||
      !userOnline.spaceConnected ||
      !userOnline.spaceConnected.id
    )
      return false;
    const spaceId = parseInt(localStorage.getItem("space_default"));
    if (spaceId == userOnline.spaceConnected.id) return false;
    return true;
  }
  joinSpace(userOnline: any) {
    this.startLoader(this.$store);
    this.$store.dispatch("SpaceStore/getSpaceByIdAction", {
      spaceId: userOnline.spaceConnected.id,
      callback: (response) => {
        this.stopLoader(this.$store);
        if (
          response.usersConnected != 0 &&
          response.usersConnected >= response.usersConnectedLimit
        ) {
          this.onWarning("", i18n.t("notifications.descriptions.spaceFull"));
        } else {
          localStorage.setItem("city", "OFF");
          localStorage.setItem(
            "space_default",
            userOnline.spaceConnected.id.toString()
          );
          window.location.reload();
        }
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
      },
    });
  }
  focusUser(): void {
    this.$store.dispatch("SidebarStore/setSidebarFullAction", true);
    const openCall = this.$store.getters["SidebarStore/getOpenCall"];
    if (openCall) {
      this.$store.dispatch("MeetingStore/setColumnDisplayAction", true);
      setTimeout(() => {
        //TODO si estas en una llamada afecta al tamaño de la vista si alguien esta en pantalla grande.
        //this.onDisplayModeChange();
        this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
      }, 20);
    }
    if (this.userOnline.connectionStatus === "ONLINE")
      this.$store.dispatch(
        "GraphicClientStore/focusUserAction",
        this.userOnline.user.id
      );
  }
  async callUser(user): Promise<void> {
    const isCall = this.$store.getters["SidebarStore/getOpenCall"];
    if (isCall) {
      this.onWarning(
        i18n.t(""),
        i18n.t("notifications.warningMessages.youAreOnCall"),
        "none"
      );
      return;
    }

    const tooltip = document.getElementsByClassName(
      "vs-tooltip left shadow"
    )[0];
    if (tooltip) tooltip.remove();
    const userLocal = this.$store.getters["UserStore/getSpaceUser"];
    let loading = null;

    if (
      user &&
      user.superSpaceUser.user.availableStatus &&
      user.superSpaceUser.user.availableStatus != RED.type
    ) {
      // avisa al cliente grafico que se puede hacer la llamada y activamos el loading.
      await this.$store.dispatch(
        "GraphicClientStore/callOneToOneOk",
        user.superSpaceUser.user.id
      );
      loading = this.$vs.loading({
        type: "circles",
        background: "#000",
        color: "#fff",
      });
    }

    await this.$store.dispatch("MeetingStore/closeMeetingSession");
    await this.$store.dispatch("MeetingStore/createMeetingOneToOneAction", {
      userId: user.id,
      callback: async (response) => {
        // si el usuario de destino esta en rojo, no nos conectamos a la llamada.
        if (
          user &&
          user.superSpaceUser.user.availableStatus &&
          user.superSpaceUser.user.availableStatus != RED.type
        ) {
          // Guardamos el status anterior.
          let pre_status = {
            availableStatus: userLocal.user.availableStatus,
            availableStatusReason: userLocal.user.availableStatusReason,
            emoji: userLocal.user.emoji,
          };
          localStorage.setItem("pre_status", JSON.stringify(pre_status));
          if (userLocal && userLocal.user.emoji != "U+1F4DE") {
            await this.$store.dispatch("UserStore/updateUserStatusAction", {
              userId: userLocal.user.id,
              props: {
                availableStatus: RED.type,
                availableStatusReason: null,
                emoji: "U+1F4DE",
              },
              callback: (user) => {
                this.$store.dispatch("SpaceStore/updateUserInSpace", user);
              },
            });
          }
          await this.$store.dispatch(
            "MeetingStore/setMeetingDataAction",
            response.data
          );
          await this.$store.dispatch("SidebarStore/setOpenCall", true);
          await this.$store.dispatch(
            "ChatStore/setMinimizeChatAction",
            !JSON.parse(localStorage.getItem("config")).chat
              .openRoomChatByDefault
          );
          await this.$store.dispatch(
            "MeetingStore/setMeetingTypeAction",
            MEETING_TYPE.ONE_TO_ONE
          );
          await this.$store.dispatch("ChatStore/setUserChatAction", user);
          setTimeout(() => {
            this.$store.dispatch(
              "GraphicClientStore/resizeGraphicClientAction"
            );
          }, 20);
          loading.close();
        } else if (user) {
          this.onWarning(
            i18n.t(""),
            i18n.t("notifications.warningMessages.isBusy", {
              name: user.superSpaceUser.user.name,
            }),
            "none"
          );
        }
      },
      callbackError: async (error) => {
        if (loading) loading.close();
        console.log("Error createMeetingOneToOneAction ", error);
      },
    });
  }
  changePermission(id: number, permission: string): void {
    if (this.isMultiWebinar) {
      this.$store.dispatch(
        "SuperSpaceUserStore/changeSuperSpaceUserHostPermissionsAction",
        {
          superSpaceUserId: id,
          data: {
            [permission]: !this.isWebinarHost,
          },
          callback: async (user) => {
            // do nothing
          },
        }
      );
    } else {
      this.$store.dispatch("SpaceUserStore/changeHostPermissionsAction", {
        spaceId: id,
        data: {
          [permission]: !this.isWebinarHost,
        },
        callback: async (user) => {
          // do nothing
        },
      });
    }
  }
  openInfoModal(): void {
    this.$store.dispatch("SystemStore/setUserInfoIdAction", this.userOnline.id);
    this.$store.dispatch("SystemStore/setOpenUserInfoModalAction", true);
  }
  disableOrEnableUser(enabled: boolean): void {
    this.$store.dispatch("SpaceUserStore/enableUserAction", {
      spaceId: this.userOnline.id,
      data: { enabled: enabled },
      callback: async (user) => {
        const tooltip = document.getElementsByClassName(
          "vs-tooltip left shadow"
        )[0];
        if (tooltip) tooltip.remove();
        this.onSuccess(
          this.$i18n.t("notifications.titles.success"),
          this.$i18n.t("notifications.descriptions.disableUser")
        );
        const auxUsers = this.$store.getters["SpaceStore/getUsersInSpace"];
        const index = auxUsers.findIndex((a) => a.id === user.id);
        if (index >= 0) {
          auxUsers.splice(index, 1, user);
          await this.$store.dispatch(
            "SpaceStore/addUsersInSpaceAction",
            auxUsers
          );
        }
      },
    });
  }
  closeMenu() {
    if (this.isOpenActions) {
      this.isOpenActions = false;
    }
  }
  isLoadText(userOnline): boolean {
    if (this.experts) {
      if (
        userOnline.user &&
        userOnline.user.curriculum &&
        userOnline.user.curriculum?.aboutYou
      ) {
        return true;
      }
    }
    if (this.knowledge) {
      if (userOnline.user && userOnline.user.experienceTag) {
        return true;
      }
    }
    if (this.projects) {
      if (userOnline.user && userOnline.user.projectParticipationTag) {
        return true;
      }
    }
    return false;
  }
  loadText(userOnline): string {
    if (this.experts) {
      if (
        userOnline.user &&
        userOnline.user.curriculum &&
        userOnline.user.curriculum.aboutYou
      ) {
        return userOnline.user.curriculum.aboutYou;
      }
    }
    if (this.knowledge) {
      if (userOnline.user && userOnline.user.experienceTag) {
        let filteredArray = userOnline.user.experienceTag.filter(
          (item) => typeof item === "string" || typeof item === "number"
        );
        let stringResult = filteredArray.join(", ");
        return stringResult;
      }
    }
    if (this.projects) {
      if (userOnline.user && userOnline.user.projectParticipationTag) {
        let filteredArray = userOnline.user.projectParticipationTag.filter(
          (item) => typeof item === "string" || typeof item === "number"
        );
        let stringResult = filteredArray.join(", ");
        return stringResult;
      }
    }
    return "";
  }
}
